var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9H4C2.9 9 2 8.1 2 7V4C2 2.9 2.9 2 4 2H16C17.1 2 18 2.9 18 4V7C18 8.1 17.1 9 16 9ZM4 3.5C3.7 3.5 3.5 3.7 3.5 4V7C3.5 7.3 3.7 7.5 4 7.5H16C16.3 7.5 16.5 7.3 16.5 7V4C16.5 3.7 16.3 3.5 16 3.5H4ZM16 18H4C2.9 18 2 17.1 2 16V13C2 11.9 2.9 11 4 11H16C17.1 11 18 11.9 18 13V16C18 17.1 17.1 18 16 18ZM4 12.5C3.7 12.5 3.5 12.7 3.5 13V16C3.5 16.3 3.7 16.5 4 16.5H16C16.3 16.5 16.5 16.3 16.5 16V13C16.5 12.7 16.3 12.5 16 12.5H4Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSectionIcon);
export default __webpack_public_path__ + "static/media/new-section-icon.890076e4958a3781bcaaf31bbcfefe14.svg";
export { ForwardRef as ReactComponent };